module.exports = {
      id: "automobile-usage",
      viewBox: "0 0 31.664 23.083",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#automobile",
      toString: function () {
        return this.url;
      }
    }